import {Component} from 'react';


class InvestmentDetailInfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, 
             selected: false,
           
        };
        this.previousCategory = "";
    }
    
       
    render() {
             
    return <>
        <div>
            <span className="container m-0 p-0">
                {this.props.investInfo.infoCat !== "" ?
                    <h6 className="font-weight-bold mt-2">{this.props.investInfo.infoCat}</h6>
                :
                    null
                }
                <span className="mx-2 row w-100 my-0 py-0">
                    <div className="col-sm-4 font-weight-bold py-0">
                        <div className="ml-2 font-weight-bold">{this.props.investInfo.itemTag}:</div>
                    </div>    
                    <div className="col-sm-8 text-left py-0">
                        <div className="ml-2">{this.props.investInfo.value}</div>
                    </div>
                </span>
            </span>
        </div>
           
    </>
    }



}

export default InvestmentDetailInfoCard;